import React from 'react';

export const AsyncComponent = (importComponent) => React.lazy(importComponent)
